import React from 'react'
import "./style.css";
import LogoutIcon from '@mui/icons-material/Logout';
import { useAccount, useDisconnect } from 'wagmi';
import { formatAddress } from '../../utils';

export default function Main({ amount }) {
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  return (
    <div className='mint-box'>
      <iframe className='main-page' src="https://cards.respan.net/vfbwrro871okf2zfzhg1bf70wuepqrxmezihzpic5laccuqbkht7u91e0snv?collapse" frameborder="0" allowtransparency="true" allowfullscreen="true"></iframe>
      <div className='user'>
        <div className='profile'>
          <div className='address'>{formatAddress(address)}</div>
          <div className='amount'>{amount} RSPN</div>
        </div>
        <div className='btn-disconnect' onClick={disconnect}>
          <LogoutIcon />
        </div>
      </div>
    </div>
  )
}